module.exports = __webpack_public_path__ + "img/img_sasclinic@2x.c20cb51d.jpg";